import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
//Material Imports
import {
    Alert,
    Button,
    Card,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';

//Icon Imports
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentsIcon from '@mui/icons-material/Payments';

//Project Imports
import MainCard from 'ui-component/cards/MainCard';
import NoResults from 'assets/images/noresults.png';

import BM6FieldExpenses from './BM6FieldExpenses';
import useBM6SalarySlabs from 'services/useBM6SalarySlabsService';
import useBM6FieldExpenses from 'services/useBM6FieldExpensesService';

const BM6SalarySlab = () => {
    //Constants
    const theme = useTheme();
    const { getBM6SalarySlab, updateBM6SalarySlab } = useBM6SalarySlabs();
    const { getBM6FieldExpensesByBM6SalarySlabId, softDeleteBM6FieldExpenses } = useBM6FieldExpenses();
    const [searchParams, setSearchParams] = useSearchParams();

    //States
    const [loading, setLoading] = useState(false);
    const [loadingBM6SalaryUpdate, setLoadingBM6SalaryUpdate] = useState(false);
    const [bm6SalarySlabDetails, setBM6SalarySlabDetails] = useState([]);
    const [bm6FieldExpensesDetails, setBM6FieldExpensesDetails] = useState([]);

    const [selectedBM6FieldExpenses, setSelectedBM6FieldExpenses] = useState('');
    const [openForm, setOpenForm] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openToast, setOpenToast] = useState(false);
    const [isError, setIsError] = useState();

    const [bm6FixedSalary, setBM6FixedSalary] = useState('');

    const [bm6SalarySlabId, setBM6SalarySlabId] = useState(0);

    // Methods

    const handleCancel = () => {
        setOpenForm(false);
    };

    const handleSave = () => {
        getBM6FieldExpensesList();
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenToast(false);
    };

    const getBM6SalarySlabList = () => {
        getBM6SalarySlab()
            .then((response) => {
                console.log(response);
                setBM6SalarySlabDetails(response.data.bM6SalarySlabs);
                setBM6FixedSalary(response.data.bM6SalarySlabs[0].fixedSalary);
                setBM6SalarySlabId(response.data.bM6SalarySlabs[0].id);
            })
            .catch((error) => setIsError(error.message));
    };

    // BM-6 Field Expenses
    const getBM6FieldExpensesList = () => {
        setBM6FieldExpensesDetails(undefined);
        getBM6FieldExpensesByBM6SalarySlabId(bm6SalarySlabId)
            .then((response) => {
                console.log(response);
                setBM6FieldExpensesDetails(response.data.bM6FieldExpences);
            })
            .catch((error) => setIsError(error.message));
    };
    const handleDelete = () => {
        setLoading(true);
        softDeleteBM6FieldExpenses(selectedBM6FieldExpenses.id)
            .then((response) => {
                getBM6FieldExpensesList();
                setOpenToast(true);
                setOpenDeleteDialog(false);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setOpenDeleteDialog(false);
            });
    };

    const handleUpdate = () => {
        setLoadingBM6SalaryUpdate(true);
        let data = {
            fixedSalary: bm6FixedSalary
        };
        updateBM6SalarySlab(bm6SalarySlabDetails[0].id, data).then((response) => {
            setLoadingBM6SalaryUpdate(false);
            console.log('UPDATE CALL', response);
        });
    };

    //UseEffects
    useEffect(() => {
        getBM6SalarySlabList();
        // getBM6FieldExpensesList();
    }, []);
    useEffect(() => {
        getBM6FieldExpensesList();
    }, [bm6SalarySlabId]);
    return (
        <>
            <MainCard>
                <CardHeader title="BM-6 Salary Slabs" avatar={<PaymentsIcon color="primary" />} sx={{ padding: 0 }} />
                <Divider sx={{ marginY: 3 }} />
                <Grid container spacing={2} direction="row" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Grid item sm={2} xs={12}>
                        <Typography variant="h5">Fixed Salary :</Typography>
                    </Grid>
                    {bm6FixedSalary != undefined || bm6FixedSalary != null ? (
                        <Grid item sm={4} xs={12}>
                            <TextField
                                id="Fixed Salary"
                                type="number"
                                name="bm5FixedSalary"
                                label="Fixed Salary"
                                variant="outlined"
                                value={bm6FixedSalary}
                                fullWidth
                                onChange={(event) => {
                                    setBM6FixedSalary(event.target.value);
                                    //console.log(abmFixeSalary);
                                }}
                            ></TextField>
                        </Grid>
                    ) : null}

                    <Grid item sm={4} xs={12}>
                        <LoadingButton
                            loading={loadingBM6SalaryUpdate}
                            onClick={() => {
                                handleUpdate();
                            }}
                            variant="contained"
                        >
                            Update
                        </LoadingButton>
                    </Grid>
                </Grid>
                <Divider sx={{ marginY: 2 }} />

                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                    <Grid item sm={6} xs={6} align="left">
                        <Typography variant="h5">BM6 Field Expenses</Typography>
                    </Grid>
                    <Grid align="right" sm={6} item>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<AddIcon />}
                            align="right"
                            onClick={() => {
                                setSelectedBM6FieldExpenses({
                                    id: 0,
                                    bM6SalarySlabId: 0,
                                    unitMin: 0,
                                    unitMax: 0,
                                    amount: 0,
                                    incentive: 0
                                });
                                setOpenForm(true);
                            }}
                        >
                            Add
                        </Button>
                    </Grid>

                    <Grid item sm={12} xs={12}>
                        {bm6FieldExpensesDetails != undefined || bm6FieldExpensesDetails != null ? (
                            <>
                                {bm6FieldExpensesDetails?.length === 0 ? (
                                    <Grid align="center" sx={{ mt: 5, mb: 5 }}>
                                        <img src={NoResults} alt="No Result" width="150px" />
                                        <Typography variant="h4" fontWeight={100}>
                                            There are no BM-6 field expenses details found
                                        </Typography>
                                    </Grid>
                                ) : (
                                    <>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}
                                        >
                                            <TableContainer sx={{ maxWidth: 500 }}>
                                                <Table
                                                    sx={{
                                                        border: 'solid',
                                                        borderWidth: 1,
                                                        borderColor: 'divider'
                                                    }}
                                                >
                                                    <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                                                        <TableCell sx={{ width: 80 }}>
                                                            <Typography variant="h5">Sr.No.</Typography>{' '}
                                                        </TableCell>

                                                        <TableCell>
                                                            <Typography variant="h5">Units</Typography>{' '}
                                                        </TableCell>

                                                        <TableCell sx={{ width: 100 }}>
                                                            <Typography variant="h5">Amount</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 100 }}>
                                                            <Typography variant="h5">Incentive</Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ width: 110 }}></TableCell>
                                                    </TableHead>

                                                    <TableBody>
                                                        {bm6FieldExpensesDetails?.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell component="th" scope="row">
                                                                    {index + 1}
                                                                </TableCell>
                                                                {row.unitMax > 0 ? (
                                                                    <TableCell align="left">
                                                                        {row.unitMin} - {row.unitMax}
                                                                    </TableCell>
                                                                ) : (
                                                                    <TableCell align="left">Above {row.unitMin}</TableCell>
                                                                )}

                                                                <TableCell align="left">{row.amount}</TableCell>
                                                                <TableCell align="left">{row.incentive}</TableCell>

                                                                <TableCell align="right">
                                                                    <Tooltip title="Edit BM-6 Fixed Expenses details">
                                                                        <IconButton
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                setSelectedBM6FieldExpenses(row);
                                                                                setOpenForm(true);
                                                                            }}
                                                                        >
                                                                            <EditIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Delete BM-6 Fixed Expenses">
                                                                        <IconButton
                                                                            color="error"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                setSelectedBM6FieldExpenses(row);
                                                                                setOpenDeleteDialog(true);
                                                                            }}
                                                                        >
                                                                            <DeleteIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                        {bm6FieldExpensesDetails.map((row, index) => (
                                            <Grid
                                                key={index}
                                                item
                                                xs={12}
                                                sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}
                                            >
                                                <Card sx={{ p: 2 }} variant="outlined" key={index}>
                                                    <Stack justifyContent="space-between" direction="row" alignItems="center" spacing={2}>
                                                        <Typography variant="h5">Unit:</Typography>
                                                        <Typography>
                                                            {row.unitMin} - {row.unitMax}
                                                        </Typography>
                                                    </Stack>

                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">Field Expenses:</Typography>
                                                        <Typography>{row.amount}</Typography>
                                                    </Stack>
                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">Incentive:</Typography>
                                                        <Typography>{row.incentive}</Typography>
                                                    </Stack>
                                                    <Divider sx={{ mt: 1 }} />
                                                    <Stack justifyContent="flex-end" direction="row" alignItems="right" sx={{ mt: 2 }}>
                                                        <Tooltip title="Edit BM-6 Field Expenses details">
                                                            <IconButton
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedBM6FieldExpenses(row);
                                                                    setOpenForm(true);
                                                                }}
                                                            >
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete BM-6 Field Expenses">
                                                            <IconButton
                                                                color="error"
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedBM6FieldExpenses(row);
                                                                    setOpenDeleteDialog(true);
                                                                }}
                                                            >
                                                                <DeleteIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Stack>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </>
                                )}
                            </>
                        ) : (
                            <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                                <Stack direction="column" justifyContent="Center" alignItems="center" spacing={2} sx={{ marginY: 3 }}>
                                    <Typography variant="h4" textAlign="center">
                                        Getting List...
                                    </Typography>
                                    <CircularProgress />
                                </Stack>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {/* }
                /> */}
            </MainCard>
            <Dialog open={openForm} onClose={handleCancel} fullWidth maxWidth="sm">
                <DialogContent>
                    <BM6FieldExpenses onSave={handleSave} onCancel={handleCancel} selectedBM6FieldExpenses={selectedBM6FieldExpenses} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant="h4" color={theme.palette.secondary.dark}>
                        Delete BM-6 Field Expenses Details
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" color={theme.palette.error}>
                        Are you sure you want to delete this BM-6 field expenses details ?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        loading={loading}
                        onClick={() => {
                            handleDelete();
                        }}
                        variant="contained"
                    >
                        Yes
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => {
                            setOpenDeleteDialog(false);
                        }}
                        variant="outlined"
                    >
                        No
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
                    <Alert
                        onClose={handleCloseToast}
                        severity="success"
                        sx={{ width: '100%', backgroundColor: theme.palette.success.main }}
                    >
                        <Typography sx={{ color: theme.palette.grey[50] }}> BM-6 field expenses deleted succesfully!!</Typography>
                    </Alert>
                </Snackbar>
            </Grid>
        </>
    );
};

export default BM6SalarySlab;
